<template>
  <div @wheel="wheelScroll" class="full-box">
    <ul class="operate-box">
      <li v-for="(item, index) in sectionList"
          @click="pageIndex=index"
          class="pointer"
          :class="pageIndex===index?'selected':''"
          :key="index"></li>
    </ul>
    <div :style="getBgPosition" class="translate-box">
      <div v-for="(item, index) in sectionList" class="page-item"
           :key="index" :style="getBgImage(item)">
        <slot :name="`section${index}`"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullScroll',
  data() {
    return {
      pageIndex: 0,
      scroll: null,
    };
  },
  props: {
    sectionList: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  computed: {
    getBgPosition() {
      const { pageIndex } = this;
      return `transform: translateY(${-(pageIndex * 100)}vh);`;
    },
  },
  methods: {
    getBgImage({ bg }) {
      return `background-image: url(${bg})`;
    },
    wheelScroll(e) {
      const { deltaY } = e;
      const { pageIndex, sectionList } = this;
      if (this.scroll === null) {
        this.scroll = setTimeout(() => {
          if (deltaY > 0) {
            // this.pageIndex = pageIndex + 1 < sectionList.length ? pageIndex + 1 : 0;
            this.pageIndex = pageIndex + 1 < sectionList.length ? pageIndex + 1 : pageIndex;
          } else {
            this.pageIndex = pageIndex > 0 ? pageIndex - 1 : 0;
          }
          this.scroll = null;
        }, 100);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.full-box{
  overflow: hidden;
  height: 100vh;
}
.operate-box{
  position: fixed;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  li{
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background-color: rgba(255,255,255, 0.4);
    margin-bottom: 10px;
  }
  .selected{
    background-color: #00BAFF;
  }
}
.translate-box{
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  -o-transition: all .5s;
}
.page-item{
  height: 100vh;
  overflow: hidden;
  background-size: 100%;
  background-position-y: 60%;
}
</style>
